import React from 'react';
import { Task } from '../../../../../types/task';

interface TaskPriorityDisplayProps {
  task: Task;
  t: (key: string) => string;
}

/**
 * 任务优先级显示组件
 * 统一使用精致的圆点样式
 */
export const TaskPriorityDisplay: React.FC<TaskPriorityDisplayProps> = ({
  task,
  t
}) => {
  if (!task.vital && !task.urgent) return null;

  if (task.vital && task.urgent) {
    return (
      <span className="mr-1.5 flex items-center">
        <span className="w-1.5 h-1.5 rounded-full bg-ios-red dark:bg-ios-dark-red mr-1"></span>
        <span className="text-ios-red dark:text-ios-dark-red">{t('priority.vitalAndUrgent')}</span>
      </span>
    );
  }

  if (task.vital) {
    return (
      <span className="mr-1.5 flex items-center">
        <span className="w-1.5 h-1.5 rounded-full bg-ios-orange dark:bg-ios-dark-orange mr-1"></span>
        <span className="text-ios-orange dark:text-ios-dark-orange">{t('priority.vital')}</span>
      </span>
    );
  }

  if (task.urgent) {
    return (
      <span className="mr-1.5 flex items-center">
        <span className="w-1.5 h-1.5 rounded-full bg-ios-blue dark:bg-ios-dark-blue mr-1"></span>
        <span className="text-ios-blue dark:text-ios-dark-blue">{t('priority.urgent')}</span>
      </span>
    );
  }

  return null;
};
